/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * ZEP QUIZ
 * Zep Quiz API
 * OpenAPI spec version: 0.0.1
 */

export type QuizsetFilterCriteriaSearchType =
  (typeof QuizsetFilterCriteriaSearchType)[keyof typeof QuizsetFilterCriteriaSearchType];

export const QuizsetFilterCriteriaSearchType = {
  ALL: 'ALL',
  TITLE: 'TITLE',
  EMAIL: 'EMAIL',
  AUTHOR_NAME: 'AUTHOR_NAME',
  QUIZSET_ID: 'QUIZSET_ID',
} as const;
